import React from 'react';
import BaseModel from '../../BaseModal'
import {
    FlexWrapperCenter,
    LineView,
    GapView
} from '../../styles/WrapperStyles';

import styled, { css } from 'styled-components';

const ParentDiv = styled.div`
  width: 200px;
  height: 400px;
  border-radius: 20px;
`;

const TextView = styled.div`
  height: 24px;
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  ${props =>
        props.cursor &&
        css`
      cursor: pointer;
    `}
`;

const ListModal = ({ closeModal, list, itemSelected }) => {
    return (
        <BaseModel closeModal={closeModal}>
            <ParentDiv>
                {list.map(item => (
                    <div key={item.id}>
                        <GapView height="10px" />
                        <FlexWrapperCenter>
                            <TextView
                                cursor
                                onClick={() => {
                                    itemSelected(item);
                                }}
                            >
                                {item.name}
                            </TextView>
                        </FlexWrapperCenter>
                        <GapView height="10px" />
                        <LineView width="200px" />
                    </div>
                ))}
            </ParentDiv>
        </BaseModel>
    );
};

export default ListModal;
